export default __webpack_public_path__ + "static/media/RU.1480d98c.svg";